import React from 'react';
import { Helmet } from 'react-helmet-async'; // ✅ SEO helmet
import AllVegetables from '../elementsui/AllVegetables';
import AllFruits from '../elementsui/AllFruits';
import HeadingSection from '../elementsui/HeadingSection';
import BottomCartNav from '../Header/BottomCartNav';

const FruitsAndVegetables = () => {
  return (
    <div className="container-fluid py-4">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Vegetables & Fruits | binzal - Farm Fresh Daily Delivery</title>
        <meta
          name="description"
          content="Shop farm-fresh vegetables and juicy fruits with binzal. Quick delivery across Bihar. Guaranteed freshness with every order!"
        />
        <meta
          name="keywords"
          content="vegetables delivery, fruits online, binzal grocery, fresh produce Bihar, order fruits vegetables"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Fresh Vegetables & Fruits | binzal" />
        <meta
          property="og:description"
          content="Buy fresh veggies and fruits online from binzal. Fast delivery in Patna, Muzaffarpur, Gaya & more Bihar cities."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://binzal.com/vegetable" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      {/* Centered section heading */}
      <div className="row justify-content-center mb-4">
        <HeadingSection headingText="Nature’s Green Basket" />
      </div>

      {/* Grid of vegetables */}
      <div className="row">
        <div className="col-12">
          <AllVegetables />
        </div>
      </div>

      <div className="row justify-content-center mb-4">
        <HeadingSection headingText="Bite into Freshness" />
      </div>

      {/* Grid of fruits */}
      <div className="row">
        <div className="col-12">
          <AllFruits />
        </div>
      </div>

      <BottomCartNav />
    </div>
  );
};

export default FruitsAndVegetables;
